import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { setupPrimeVue } from '@/plugins/primevue'
import '@/theme/tailwind.css'

// Build id (cache-bust) : force un changement de hash bundle a chaque
// modification, pour que les clients ayant un ancien index.html en cache
// recoivent forcement le nouveau JS (l'ancien hash n'est plus reference).
const BUILD_ID = '2026-05-13-1'
if (typeof window !== 'undefined') {
  (window as any).__ADMIN_BUILD_ID__ = BUILD_ID
}

const app = createApp(App)

const pinia = createPinia()
// v4 API : on doit appeler la factory createPersistedState(),
// pas passer le default plugin directement.
pinia.use(createPersistedState())
app.use(pinia)

app.use(router)
setupPrimeVue(app)

app.mount('#app')
